import { render, staticRenderFns } from "./LgFinderPageTipoAditivo.vue?vue&type=template&id=41fb64de"
import script from "./LgFinderPageTipoAditivo.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoAditivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports